import { products } from "./js/data";
import {renderItem}  from "./js/render";
import {initCart} from "./js/cart";


renderItem(products)

initCart(products)